export default __webpack_public_path__ + "static/media/login-bg-left.52e2931f.jpg";